/** Minimal DOM overlay for the world entrance — loading copy and anchored load bar. */
export function entranceProgressPercent(fraction: number): number {
  const clamped = Math.min(1, Math.max(0, fraction));
  if (clamped >= 1) return 100;
  return Math.floor(clamped * 100);
}

export class EntranceHud {
  private readonly root: HTMLElement;
  private readonly welcomeEl: HTMLElement;
  private readonly progressEl: HTMLElement;
  private readonly progressBar: HTMLElement;
  private welcomeVisible = false;

  constructor(parent: HTMLElement) {
    this.root = document.createElement('div');
    this.root.className = 'gii-entrance-hud';
    this.root.setAttribute('aria-hidden', 'true');

    this.welcomeEl = document.createElement('div');
    this.welcomeEl.className = 'gii-entrance-welcome';

    const title = document.createElement('p');
    title.className = 'gii-entrance-welcome-title';
    title.textContent = 'Loading…';

    this.welcomeEl.append(title);

    this.progressEl = document.createElement('div');
    this.progressEl.className = 'entrance-status entrance-status--progress gii-entrance-progress';
    this.progressEl.setAttribute('aria-live', 'polite');

    const track = document.createElement('div');
    track.className = 'entrance-status-track';
    track.setAttribute('aria-hidden', 'true');
    this.progressBar = document.createElement('div');
    this.progressBar.className = 'entrance-status-bar';
    track.appendChild(this.progressBar);
    this.progressEl.append(track);

    this.root.append(this.welcomeEl, this.progressEl);
    parent.appendChild(this.root);
  }

  setWelcomeTitle(text: string): void {
    const title = this.welcomeEl.querySelector('.gii-entrance-welcome-title');
    if (title) title.textContent = text;
  }

  showWelcome(): void {
    this.welcomeVisible = true;
    this.welcomeEl.classList.add('gii-entrance-welcome--visible');
  }

  hideWelcome(): void {
    if (!this.welcomeVisible) return;
    this.welcomeVisible = false;
    this.welcomeEl.classList.remove('gii-entrance-welcome--visible');
    this.welcomeEl.classList.add('gii-entrance-welcome--hidden');
  }

  showProgress(): void {
    this.progressEl.classList.add('gii-entrance-progress--visible');
  }

  hideProgress(): void {
    this.progressEl.classList.remove('gii-entrance-progress--visible');
  }

  setProgress(fraction: number): void {
    const pct = entranceProgressPercent(fraction);
    this.progressBar.style.width = `${pct}%`;
  }

  dispose(): void {
    this.root.remove();
  }
}
